import React, { useState } from 'react';

import {
  makeStyles,
  TableRow,
  TableCell,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core';
import { AddBox, DeleteOutline, ListAltSharp } from '@material-ui/icons';
import { ModalIngresoEvolucionOdonto } from './ModalIngresoEvolucionOdonto';
import {
  fetchEvolucionesOdontologia,
  pasarErrorProblemaOdonto,
} from '../../../../actions/hce/hceActions';
import { useDispatch } from 'react-redux';
import { ModalDetalleEvoluciones } from './ModalDetalleEvoluciones';

const useStyles = makeStyles({
  iconEstado: {
    '&:hover': {
      backgroundColor: '#80808026',
    },
  },
});

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const EvolucionesOdontoHistorialItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [openProblemaInfo, setOpenProblemaInfo] = useState(false);
  const [openModalEvolucion, setOpenModalEvolucion] = useState(false);
  const [idProblemaOdontologico, setIdProblemaOdontologico] = useState('');
  const [tituloModal, setTituloModal] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { problema, hce, disabled } = props;

  const handleDelete = () => {
    setConfirmOpen(!confirmOpen);
  };

  return (
    <React.Fragment>
      {openModalEvolucion && (
        <ModalIngresoEvolucionOdonto
          open={openModalEvolucion}
          close={() => {
            setOpenModalEvolucion(false);
          }}
          titulo={tituloModal}
          disabled={disabled}
          idProblemaOdontologico={idProblemaOdontologico}
          hce={hce}
        />
      )}
      {openProblemaInfo && (
        <ModalDetalleEvoluciones
          open={openProblemaInfo}
          close={() => {
            setOpenProblemaInfo(false);
          }}
          titulo={tituloModal}
          disabled={disabled}
          hce={hce}
        />
      )}
      <TableRow className={classes.iconEstado}>
        <TableCell>
          {!disabled &&
            <Fab
              disabled={disabled}
              color="primary"
              aria-label="add"
              size="small"
              onClick={() => {
                setTituloModal('Ingreso evolucion');
                setOpenModalEvolucion(true);
                setIdProblemaOdontologico(problema?.id);
              }}
            >
              <AddBox />
            </Fab>
          }
        </TableCell>
        <TableCell>{problema?.nroPieza}</TableCell>
        <TableCell>{problema?.codNom}</TableCell>
        <TableCell>{problema?.descripcionNomenclador}</TableCell>
        <TableCell>{problema?.nombreEfector}</TableCell>
        <TableCell>
          {new Date(problema?.fechaCarga).toLocaleString('es', optionsfecha)}
        </TableCell>
        {problema?.idEfectorRed === hce.idEfector ? (
          <TableCell>
            {!disabled &&
              <Fab
                disabled={disabled}
                color="primary"
                aria-label="add"
                size="small"
                onClick={handleDelete}
              >
                <DeleteOutline />
              </Fab>
            }
            <Dialog open={confirmOpen} onClose={handleDelete}>
              <DialogTitle>Mensaje</DialogTitle>
              <DialogContent>
                <Typography>
                  ¿Estás seguro de que deseas pasar a error el problema?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  disabled={disabled}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    const data = {
                      id: problema?.id,
                    };
                    dispatch(pasarErrorProblemaOdonto(data, hce.idAfiliado, hce.idAfiliadoExterno));
                    setConfirmOpen(false);
                  }}
                >
                  Sí
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDelete}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </TableCell>
        ) : (
          <div></div>
        )}

        <TableCell>
          <Fab
            color="primary"
            aria-label="add"
            size="small"
            onClick={() => {
              setOpenProblemaInfo(
                (prevOpenMedicamentoInfo) => !prevOpenMedicamentoInfo,
              );
              setTituloModal('Detalle evoluciones');
              dispatch(fetchEvolucionesOdontologia(problema?.id));
            }}
          >
            <ListAltSharp />
          </Fab>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
